import { render } from "./Leaderboards.vue?vue&type=template&id=1230bc09&scoped=true"
import script from "./Leaderboards.vue?vue&type=script&lang=js"
export * from "./Leaderboards.vue?vue&type=script&lang=js"

import "./Leaderboards.vue?vue&type=style&index=0&id=1230bc09&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1230bc09"]])

export default __exports__